import React from 'react';

// Small line icons for the product-admin portal layout
const Svg = ({ size = 20, children, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    {children}
  </svg>
);

export const LayersIcon = (props) => (
  <Svg {...props}><path d="M12 3 3 8l9 5 9-5-9-5Z" /><path d="m3 13 9 5 9-5" /></Svg>
);
export const GridIcon = (props) => (
  <Svg {...props}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></Svg>
);
export const BuildingIcon = (props) => (
  <Svg {...props}><path d="M4 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16" /><path d="M14 10h5a1 1 0 0 1 1 1v10" /><path d="M2 21h20" /><path d="M8 8h2M8 12h2M8 16h2" /></Svg>
);
export const FileCheckIcon = (props) => (
  <Svg {...props}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" /><path d="M14 3v5h5" /><path d="m9 14 2 2 4-4" /></Svg>
);
export const FileTextIcon = (props) => (
  <Svg {...props}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h4" /></Svg>
);
export const PenIcon = (props) => (
  <Svg {...props}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" /></Svg>
);
export const ActivityIcon = (props) => (
  <Svg {...props}><rect x="3" y="3" width="18" height="18" rx="3" /><path d="m7 13 3-3 3 3 4-5" /></Svg>
);
export const ChartIcon = (props) => (
  <Svg {...props}><path d="M3 20h18" /><path d="m4 15 4-5 4 3 5-7 3 3" /><path d="M5 20v-2M9 20v-4M13 20v-5M17 20v-8M21 20v-6" opacity=".6" /></Svg>
);
export const UsersIcon = (props) => (
  <Svg {...props}><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><path d="M16 4.6a3.5 3.5 0 0 1 0 6.8" /><path d="M18 14.2a6.5 6.5 0 0 1 3.5 5.8" /></Svg>
);
export const SearchIcon = (props) => (
  <Svg {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Svg>
);
export const FilterIcon = (props) => (
  <Svg {...props}><path d="M3 5h18l-7 8v6l-4-2v-4L3 5Z" /></Svg>
);
export const ArrowRightIcon = (props) => (
  <Svg {...props}><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></Svg>
);
export const LogoutIcon = (props) => (
  <Svg {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></Svg>
);
export const ReceiptIcon = (props) => (
  <Svg {...props}><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" /><path d="M9 8h6M9 12h6" /></Svg>
);
export const UploadIcon = (props) => (
  <Svg {...props}><path d="M12 16V4" /><path d="m7 9 5-5 5 5" /><path d="M5 20h14" /></Svg>
);
export const PlusIcon = (props) => (
  <Svg {...props}><path d="M12 5v14M5 12h14" /></Svg>
);
export const EyeOpenIcon = (props) => (
  <Svg {...props}><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" /></Svg>
);
